/* global ERROR_MSG, bootstrap, Vimeo, _paq, gsap, ERROR_MSG */
(function app(utils) {
    const { qsa, qs, testEmail, checkPasswordComplexity, checkNPI, populateNPIFields, els, isElementViewport, updateValidatedField, xuFetch, domReady, formatPhoneNumber, updateSubmitBtn, bootstrapModal, validateRequiredFields, generateVCard } = utils;
    const { domainSite, nonce, userID, userNPI, isLoggedIn, notifications } = window.siteMeta;
    const queryString = window.location.search;
    const ELS = {
        ...els,
        // Form fields
        restrictName:       qsa('.restrict-name'),
        phone:              qsa('.phone-input'),
        // Menu
        abrirMenu:          qs('.abrirMenu'),
        menu:               qs('#main-menu'),
        subMenuCoursesDiv:  qs('#site-header .courses .dropdown-menu'),
        isiTray:            qs('.isi-tray'),
        toggleTray:         qsa('.toggle-tray'),
        links:              qsa('a:not(.videoModal)'),
        goLink:             qs('#modalUrl .go-link'),
        eyes:               qsa('form span.eye'),
        resetPassForm:      qs('form[name="reset_password"]'),
        recruiterForm:      qs('#recruit-friend'),
        recruiterBtn:       qs('#recruit-friend button[type="submit"]'),
        videoModal:         qs('#modalVideo'),
        videoModalEmbed:    qs('#modalVideo .embedVideo'),
        notificationBanner: qs('[data-notification-banner]'),
        notificationMsgs:   qs('[data-notification-msgs]'),
        notificationNum:    qs('[data-notification-num]'),
        notificationTpl:    qs('[data-notification-tpl]'),
        siteHeader:         qs('#site-header'),
        successRegister:    qs('#successRegister'),
        forgotPassForm:     qs('form[name="forgot_password"]'),
        vCardLinks:         qsa('a[data-generate="vcard"]'),
        toolTips:          qsa('[data-bs-toggle="tooltip"]'),
    };

    const MODAL = {
        video:           bootstrapModal('#modalVideo'),
        registerSuccess: bootstrapModal('#successRegister'),
        sentMail:        bootstrapModal('#sentMail'),
    };

    /**
     * The following elements need to be tracked by GTM so they need data-event-category and data-event-label added to them
     * We need an array with the selector, the category and the label
     */
    const GTM_ELEMENTS = [
        // Cookie Settings Open  
        ['button.ot-floating-button__open', 'Header', 'Cookie Settings Click'],
        // Inout Blocking - Performance Cookies Not Allowed
        ['#ot-group-id-C0002', 'Header', 'Toggle - Performance Cookies'],
        // Inout Blocking - Targeting Cookies Not Allowed
        ['#ot-group-id-C0003', 'Header', 'Toggle - Targeting Cookies'],
        // Button Accept All Cookies
        ['#accept-recommended-btn-handler', 'Header', 'Allow All'],
        // Button Reject All Cookies
        ['button.ot-pc-refuse-all-handler', 'Header', 'Reject All'],
        // Button - Confirm
        ['button.save-preference-btn-handler', 'Header', 'Confirm My Choices'],
    ];


    /**
     * GSAP global Timelines.
     */
    const TL = {
        notification: gsap.timeline({ paused: true }).fromTo(ELS.notificationBanner, {
            height: 0,
            y:      0,
        }, {
            height:   'auto',
            duration: 1,
            delay:    0.5,
            y:        () => ELS.siteHeader.offsetHeight,
            ease:     'power2.out',
        }),
    };

    /**
     * Scroll to a specific section using hashes.
     * @param {String} hash hash value of the section
     * @param {int} delay delay in milliseconds.
     * @returns null
     */
    const scrollToHash = (hash = null, delay = 0, duration = 0.5) => {
        if (!hash) return;

        const element = qs(`${hash}_hash`) || qs(hash);

        if (!element) return;

        setTimeout(() => {
            gsap.to(window, {
                duration,
                scrollTo: {
                    y:        `#${element.id}`,
                    offsetY:  qs('#site-header').offsetHeight,
                    ease:     'power2',
                    autoKill: false,
                },
            });
        }, delay);
    }

    function dropDownsOnHover() {
        const dds = [];
        const tls = [];
        qsa('.dropdown-hover').forEach((dropdown, i) => {
            const menu = qs('.dropdown-menu', dropdown.parentNode);
            dds[i] = new bootstrap.Dropdown(dropdown);
            tls[i] = gsap.timeline({ paused: true }).fromTo(menu, { 
                opacity: 0, 
                y: -10, 
                display: 'none',
            }, {
                opacity: 1, 
                y: 0,
                 display: 'block', 
                duration: 0.3, 
                ease: 'ease-out',
                onStart: () => {
                    gsap.set(menu, { clearProps: 'transform' });
                },
                onComplete: () =>{
                    dds.forEach((dd, j) => {
                        if (j !== i) {
                            dd?.hide();
                            tls[j]?.reverse();
                        }
                    });
                    dds[i].show()
                },
                onReverseComplete:() => {
                    dds[i]?.hide();
                    menu.style.transform = '';
                },
            });

            dropdown.addEventListener('mouseleave', (e) => {
                if (!e.toElement.closest('.dropdown-center')) tls[i].reverse();
            });
            dropdown.addEventListener('mouseenter', () => tls[i].play());
            menu.addEventListener('mouseleave', () =>  tls[i].reverse());

            // If there is a click outside of the dropdown and its opened, close it
            document.addEventListener('click', (e) => {
                if (!e.target.closest('.dropdown-center')) {
                    tls[i]?.reverse();
                }
            });

        });
    }

    /**
     * Dismiss notifications banner click event.
     * TODO: Make this save the state.
     */
    function dismissNotificationsClick() {
        const single = this.closest('[data-notification-single]');
        if (!single) return;

        const id = this.dataset.notificationId;

        gsap.to(single, {
            height: 0,
            onComplete() {
                single.remove();
                const num = ELS.notificationMsgs.children.length;
                ELS.notificationNum.innerHTML = `${num}&nbsp;new message${num === 1 ? '' : 's'}`;
                if (num < 1)
                    TL.notification.reverse();

                xuFetch({
                    action:   'dismiss_notification',
                    _wpnonce: nonce.dismissNotificationForUser,
                    id,
                });
            },
        });
    }

    /**
     * Check for new notifications and animate the banner.
     */
    const checkNotifications = () => {
        if (!notifications.length) return;

        ELS.notificationNum.innerHTML = `${notifications.length}&nbsp;new message${notifications.length === 1 ? '' : 's'}`;
        notifications.forEach((notification) => {
            const tpl = ELS.notificationTpl.content.cloneNode(true);
            const btn = qs('[data-notification-dismiss]', tpl);
            qs('[data-notification-title', tpl).textContent = `${notification.title}:`;
            qs('[data-notification-msg', tpl).innerHTML = notification.content;
            btn.dataset.notificationId = notification.id;
            btn.addEventListener('click', dismissNotificationsClick);
            ELS.notificationMsgs.appendChild(tpl);
        });
        // animate banner using gsap
        TL.notification.play();
    };

    const windowOnLoad = () => {
        if (!window.location.hash) return;

        // const hash      = window.location.hash.substring(1);
        const modalHash = qs(`${window.location.hash}.modal`);

        // Look for modals with the hash in the id.
        if (modalHash)
            bootstrapModal(modalHash).show();
    };

    /**
     * Check for query string and show modal if needed.
     */
    const checkForQueryString = () => {
        switch (queryString) {
        case '?checkemail=confirm':
        case '?resetpass=complete':
            MODAL.sentMail.show();
            break;
        case '?success-login':
            if (+userID) {
                // TODO: Remove Matomo after.
                window._mtm.push({
                    event: 'user_id',
                    id:    userID,
                    npi:   userNPI,
                });
                // Push custom event to GTM
                window.dataLayer.push({ event: 'user_login', user_id: userID, npi: userNPI });
            }
            break;
        default:
            break;
        }
    };

    /**
     * Restrict name input to letters, spaces, and hyphens.
     */
    function restrictName() {
        this.value = this.value.replace(/[^A-Za-z\s-]/gi, '');
    }

    /**
     * Restrict NPI input to numbers and 10 characters.
     */
    const npiInput = () => {
        let npiNumber = ELS.npiField.value;
        npiNumber = npiNumber.replace(/[^0-9]/gi, '');
        if (npiNumber >= 10)
            npiNumber = npiNumber.substring(0, 10);

        ELS.npiField.value = npiNumber;
    };

    const npiInputOnBlur = async () => {
        const npi = ELS.npiField.value;
        window.siteMeta.NPI_VALIDATED = false;

        if (!npi) {
            updateValidatedField(ELS.npiField, 'is-invalid', 'NPI is required.');
            return;
        }

        if (npi.length !== 10) {
            updateValidatedField(ELS.npiField, 'is-invalid', 'NPI must be 10 digits.');
            return;
        }

        const checkMyNPI = await checkNPI(npi);

        if (!checkMyNPI) {
            updateValidatedField(ELS.npiField, 'is-invalid', ERROR_MSG.NPI_INVALID);
            return;
        }

        window.siteMeta.NPI_VALIDATED = true;
        populateNPIFields(checkMyNPI);
        updateValidatedField(ELS.npiField, 'is-valid', 'NPI is valid.');
    };

    /**
     * Toggle the footer active class depending on if it's in the viewport.
     */
    const onWIndowScroll = () => {
        if(!ELS.footer) ELS.footer = qs('#site-footer');
        if(!ELS.isiTray) ELS.isiTray = qs('.isi-tray');
        ELS.footer.classList.toggle('isi-active', !isElementViewport(ELS.footer, { offset: ELS.isiTray.offsetHeight + 80 }))
    };

    /**
     * Set the GTM data attributes to the elements.
     */
    const setGTMAttributes = () => {
        // Delay the setting of the attributes to make sure the elements are loaded.
        setTimeout(() => {
            GTM_ELEMENTS.forEach(([selector, category, label]) => {
                qsa(selector).forEach((el) => {
                    el.dataset.eventCategory = category;
                    el.dataset.eventLabel = label;
                });
            });
        }, 1000);
    }

    const init = () => {
        setGTMAttributes();
        checkForQueryString();
        checkNotifications();
        dropDownsOnHover();

        scrollToHash(window.location.hash, 300);
        window.addEventListener('hashchange', () => scrollToHash(window.location.hash, 300));

        window.addEventListener('load', windowOnLoad);
        window.addEventListener('scroll', onWIndowScroll);
        ELS.restrictName.forEach(input => input.addEventListener('input', restrictName));
        ELS.npiField?.addEventListener('input', npiInput);
        ELS.npiField?.addEventListener('blur', npiInputOnBlur);

        // Init tooltips
        ELS.toolTips.forEach((tooltip) => {
            tooltip.dataset.bsCustomClass = 'custom-tooltip';
            tooltip.dataset.bsHtml = true;
            new bootstrap.Tooltip(tooltip)
        });

        // Generate vCard Links
        ELS.vCardLinks.forEach((link) => {
            const { firstName, lastName, address, phoneNumber, email } = link.dataset;
            link.href = generateVCard(firstName, lastName, address, phoneNumber, email);
            link.download = `${firstName}-${lastName}.vcf`;
        });

        // Format phone number input to (999) 999-9999.
        ELS.phone.forEach(input => {
            const numberCB = () => {
                input.value = formatPhoneNumber(input.value);
            };
            input.addEventListener('input', numberCB);
            input.addEventListener('blur', numberCB);
        });

        ELS.understand?.addEventListener('change', () => ELS.understand.classList.toggle('is-invalid', !ELS.understand.checked));

        ELS.wcpForm?.addEventListener('submit', e => e.preventDefault());
    };

    /**
     * Open the video modal and play the video.
     */
    qsa('a.videoModal').forEach((video) => video.addEventListener('click', (e) => {
        e.preventDefault();
        const loadingText = qs('h6', ELS.videoModal);
        const videoTitle  = qs('h2', ELS.videoModal);

        // remove https:// from href
        let linkVideo = video.href.replace('https://', '');
        linkVideo = linkVideo.split('?'); // Split by ?
        const [, videoID, videoHash] = linkVideo[0].split('/'); // Split by /
        const title = qs('h6', video.parentNode)?.textContent || '';
        const videoURL = `https://player.vimeo.com/video/${videoID}/?h=${videoHash}${isLoggedIn ? '&badge=0&autopause=0&player_id=0&app_id=58479' : ''}}`;
        const iframe   = document.createElement('iframe');
        iframe.src = videoURL;
        iframe.frameborder = 0;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowfullscreen = true;
        const player = new Vimeo.Player(iframe);

        // Adjust the modal to the video
        gsap.to(loadingText, { opacity: 1, duration: 0.5 });
        ELS.videoModalEmbed.appendChild(iframe);

        // Send the event to Matomo
        _paq.push(['MediaAnalytics::scanForMedia']);

        // Play the video
        videoTitle.innerHTML = title;
        MODAL.video.show();
        player.play();
        setTimeout(() => gsap.to(loadingText, { opacity: 0, duration: 0.5 }), 2000);

        if (!isLoggedIn) return;

        xuFetch(
            {
                action:   'saveVideo',
                _wpnonce: nonce.saveVideo,
                videoID,
            },
        );
    }));

    /**
     * This seems to be a download video of a PDF instead of a video.
     */
    qsa('a.downloadAsset').forEach((download) => {
        if (!isLoggedIn) return;
        download.addEventListener('click', () => {
           xuFetch(
                {
                    action:   'saveDownload',
                    _wpnonce: nonce.saveDownload,
                    id: download.dataset.id
                },
            );
        });
    });

    // Toggle menu.
    ELS.abrirMenu?.addEventListener('click', () => {
        console.log('abrirMenu click');
        ELS.abrirMenu.classList.toggle('change');
        ELS.menu.classList.toggle('active');
        ELS.body.classList.toggle('menu-active');
    });

    qsa('li a', ELS.menu).forEach(link => ELS.subMenuCoursesDiv.classList.remove('removeHover'));
    qsa('li ul li a', ELS.menu).forEach((link) => {
        link.addEventListener('click', () => {
            console.log('link click', link);
            ELS.abrirMenu.classList.remove('active');
            ELS.menu.classList.remove('active');
            // ELS.$subMenuCoursesDiv.addClass('removeHover');
            // ELS.subMenuCoursesDiv.classList.add('removeHover');
        });
    });

    // Toggle ISI tray body class.
    ELS.toggleTray.forEach(toggle => toggle.addEventListener('click', () => ELS.body.classList.toggle('active-isi')));
    ELS.links.forEach((link) => {
        if (link.href.indexOf('javascript') > -1 || link.href.indexOf(domainSite) > -1 || link.href === '' || link.href === '#')
            return;

        link.removeAttribute('target');
        link.setAttribute('data-link', link.href);
        link.href = '#';
        link.setAttribute('data-bs-toggle', 'modal');
        link.setAttribute('data-bs-target', '#modalUrl');
        link.classList.add('modalLink');
    });

    // When the modalLink is clicked, set the href of the modal button to the link.
    ELS.body.addEventListener('click', (e) => {
        if (e.target.matches('.modalLink') || e.target.closest('.modalLink'))
            ELS.goLink.href = e.target.dataset.link || e.target.closest('.modalLink').dataset.link;
    });

    // When the go btn is clicked in the modal, open the link in a new tab.
    ELS.goLink?.addEventListener('click', () => window.open(ELS.goLink.href, '_blank'));

    // Toggle password visibility.
    ELS.eyes.forEach((eye) => {
        const input = qs('input', eye.parentElement);
        eye.addEventListener('click', () => {
            const isActive = eye.classList.contains('active');
            input.setAttribute('type', isActive ? 'password' : 'text');
            eye.classList.toggle('active');
        });
    });

    /**
     * Send a recruit request to a friend.
     * TODO: Remove contact form 7.
     */
    ELS.recruiterForm?.addEventListener('submit', (e) => {
        e.preventDefault();
        let valid = true;
        const nameFriend  = qs('.friend', ELS.recruiterForm);
        const emailFriend = qs('.friendEmail', ELS.recruiterForm);

        qsa('.is-invalid', ELS.recruiterForm).forEach(el => el.classList.remove('is-invalid'));

        updateSubmitBtn('Sending...', ELS.recruiterBtn);

        if (nameFriend.value.length < 2) {
            updateValidatedField(nameFriend, 'is-invalid');
            valid = false;
        }

        if (!testEmail(emailFriend.value)) {
            updateValidatedField(emailFriend, 'is-invalid');
            valid = false;
        }

        if (!valid) {
            updateSubmitBtn('__default__', ELS.recruiterBtn);
            return
        };

        xuFetch({
            action:   'recruit_friend',
            _wpnonce: nonce.recruitFriend,
            friendName: nameFriend.value,
            friendEmail: emailFriend.value,
        },
        null,
        null,
        // Finally
        () => {
            bootstrapModal('#recruitMember').show();
            updateSubmitBtn('__default__', ELS.recruiterBtn);
            // reset form
            ELS.recruiterForm.reset();
        }
        );
    });

    ELS.forgotPassForm?.addEventListener('submit', (e) => {
        e.preventDefault();

        const userLogin = qs('#user_login', ELS.forgotPassForm);

        // reset errors
        userLogin.classList.remove('is-invalid', 'is-valid');

        updateSubmitBtn('Please wait...', ELS.forgotPassForm.submit);

        // If the user_login is empty, show error.
        if (!userLogin.value) {
            updateValidatedField(userLogin, 'is-invalid', 'Please enter a username or email address.');
            updateSubmitBtn('__default__', ELS.forgotPassForm.submit);
            return;
        }

        // Too short
        if (userLogin.value.length < 3) {
            updateValidatedField(userLogin, 'is-invalid', 'Username or email address is too short.');
            updateSubmitBtn('__default__', ELS.forgotPassForm.submit);
            return;
        }

        // Send it over to the server.
        xuFetch(
            ELS.forgotPassForm,
            // success
            (res) => {
                const { success, data } = res;
                updateValidatedField(userLogin, 'is-valid', data);
                updateSubmitBtn('Success!', ELS.forgotPassForm.submit);
                // Open the modal.
                MODAL.sentMail.show();
            },
            // Error
            (error) => {
                const { data } = error;
                updateValidatedField(userLogin, 'is-invalid', data);
                updateSubmitBtn('Error', ELS.forgotPassForm.submit, false);
            },
        );
    });

    // When the video modal is hidden, remove the video.
    ELS.videoModal?.addEventListener('hide.bs.modal', () => { ELS.videoModalEmbed.innerHTML = ''; });

    ELS.resetPassForm?.addEventListener('submit', (e) => {
        e.preventDefault();
        const pass1 = qs('#user_pass', ELS.resetPassForm);
        const pass2 = qs('#user_pass_confirm', ELS.resetPassForm);

        // reset errors
        qsa('.is-invalid, .is-valid', ELS.resetPassForm).forEach(el => el.classList.remove('is-invalid', 'is-valid'));

        updateSubmitBtn('Saving...', ELS.resetPassForm.submit);

        if (pass1.value.length < 8) {
            updateValidatedField(pass1, 'is-invalid', ERROR_MSG.PASS_MIN_LENGTH);
            updateSubmitBtn('__default__', ELS.resetPassForm.submit);
            return;
        }

        if (!checkPasswordComplexity(pass1.value)) {
            updateValidatedField(pass1, 'is-invalid', ERROR_MSG.PASS_ERROR);
            updateSubmitBtn('__default__', ELS.resetPassForm.submit);
            return;
        }

        if (pass1.value !== pass2.value) {
            updateValidatedField(pass2, 'is-invalid', ERROR_MSG.PASS_CONFIRM_NOT_MATCH);
            updateSubmitBtn('__default__', ELS.resetPassForm.submit);
            return;
        }

        // Send it over to the server.
        xuFetch(
            ELS.resetPassForm,
            // success
            (res) => {
                const { data } = res;
                // add the msg after the form
                ELS.resetPassForm.insertAdjacentHTML('afterend', `<div class="title-graduate">${data}</div>`);
                // remove the form
                ELS.resetPassForm.remove();
            },
            // Error
            (error) => {
                const { data } = error;
                updateValidatedField(pass1, 'is-invalid', ERROR_MSG[data] || data);
                updateSubmitBtn('Error', ELS.resetPassForm.submit, false);
            },
        );
    });

    // Init
    domReady(init);
}(window.utilities));
